import { render } from "./RefDestinations.vue?vue&type=template&id=2c8c64e7&scoped=true"
import script from "./RefDestinations.vue?vue&type=script&lang=js"
export * from "./RefDestinations.vue?vue&type=script&lang=js"

import "./RefDestinations.vue?vue&type=style&index=0&id=2c8c64e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8c64e7"]])

export default __exports__